const Encounters = [
  {
    name: "The Warding Spell",
    description:
      "A group of astroliches are summoning a dreadnaught class starship just 10 lightyears from an inhabited ecumenopolis. If they complete the ritual, the world will be poisoned from orbit and converted to an army of undead in less than an hour. The liches can not be harmed during the ritual. Their spellcasting must be distracted or disrupted before they can be harmed. Nearby, lazily munching on an asteroid, is the ancient space whale Gorvanox.",
    pointsOfInterest: [
      "8 Astroliches",
      "Kaltharon, the City Planet",
      "Final Ossuary, the Lich Dreadnaught",
      "Gorvanox the Space Whale",
    ],
    rolls: [
      { name: "Astroliches", bonus: 4 },
      { name: "Final Ossuary", bonus: 20 },
      { name: "Gorvanox the Space Whale", bonus: 8 },
    ],
  },
  {
    name: "The Searing Nova",
    description:
      "A massive interstellar war-creature known as the Sol-Bane is absorbing the energy of a nearby dwarf star. The Xeraxian armada, a fleet of plasma-fueled battlecruisers, stands between the party and the Sol-Bane. If the Sol-Bane completes the absorption process, it will initiate a supernova, incinerating nearby star systems including the thriving biotech utopia of Genara IV. To make things even more complicated, the star is inhabited by sentient energy beings, the Starborn, who are inextricably linked to its fate.",
    pointsOfInterest: [
      "The Sol-Bane, an Interstellar War-Creature",
      "The Xeraxian Armada, Plasma-Fueled Battlecruisers",
      "Genara IV, the Biotech Utopia",
      "Starborn, the Sentient Energy Beings",
    ],
    rolls: [
      { name: "Sol-Bane", bonus: 12 },
      { name: "Xeraxian Armada", bonus: 6 },
      { name: "Starborn", bonus: 10 },
    ],
  },
  {
    name: "Echoes of the Time-Vortex",
    description:
      "A rogue faction of the Chronosian Order, time-traveling ascetics known as the Time-Rifters, are attempting to fold the timeline to change the outcome of the brutal galaxy-consuming war. Their base of operations is located inside a dying star - the Chronos Nova, where time dilates due to extreme gravitational pull. Should they succeed, the galaxy's present state will be disrupted, possibly causing massive socio-political chaos or even a paradoxical collapse of reality. In addition, the dying star houses a sentient celestial entity, the Temporal Leviathan, which is awakening due to the Time-Rifters' activities.",
    pointsOfInterest: [
      "The Time-Rifters, Rogue Faction of the Chronosian Order",
      "Chronos Nova, the Dying Star & Time-Base",
      "The Temporal Leviathan, the Sentient Celestial Entity",
    ],
    rolls: [
      { name: "Time-Rifters", bonus: 8 },
      { name: "Chronos Nova", bonus: 16 },
      { name: "Temporal Leviathan", bonus: 14 },
    ],
  },
  {
    name: "The Nebular Choir",
    description:
      "In the cosmic echoes of the Ghul Nebula, an ancient race of psionic entities known as the Nebular Sirens are singing a psychic dirge that induces hallucinations and despair across star systems. Their song is directed at a colossal cosmic horror, the Kraken Nebulon, trapped in a celestial prison within the heart of the nebula, in an attempt to awaken it. If they succeed, the Kraken Nebulon will be unleashed to devastate the galaxy. In addition, the Nebular Sirens' song has attracted a group of zealot space pirates, the Star Reavers, who see the awakening of the Kraken Nebulon as a path to ultimate power.",
    pointsOfInterest: [
      "The Nebular Sirens, Psychic Entities",
      "Ghul Nebula, Cosmic Psychic Echoes",
      "Kraken Nebulon, the Cosmic Horror",
      "Star Reavers, the Zealot Space Pirates",
    ],
    rolls: [
      { name: "Nebular Sirens", bonus: 10 },
      { name: "Star Reavers", bonus: 6 },
      { name: "Kraken Nebulon", bonus: 15 },
    ],
  },
  {
    name: "The Quantum Manifestation",
    description:
      "Deep within the reality-bending Maelstrom Vortex, a colossal Quantum Golem has formed, a semi-sentient entity born of the chaotic quantum energy and is becoming increasingly unstable. Its existence is causing ripples in the fabric of reality, resulting in random teleportations and transmutations within a several light-years radius. The Omicron Consortium, a group of advanced AI network, attempts to harness the golem's energy to upgrade their processing power exponentially, ignoring the threat to the stability of reality. Unbeknownst to them, the Quantum Golem has started attracting the attention of Voidstalkers, interdimensional predators, due to the reality rifts.",
    pointsOfInterest: [
      "Quantum Golem, the Semi-Sentient Entity",
      "Maelstrom Vortex, the Reality-Bending Space Anomaly",
      "Omicron Consortium, the Advanced AI Network",
      "Voidstalkers, the Interdimensional Predators",
    ],
    rolls: [
      { name: "Quantum Golem", bonus: 18 },
      { name: "Omicron Consortium", bonus: 10 },
      { name: "Voidstalkers", bonus: 14 },
    ],
  },
  {
    name: "The Derelict Dreadnaught",
    description:
      "In the icy rings of a distant gas giant, a long-abandoned dreadnaught, known as the 'Harbinger of Silence,' has suddenly powered up again. The ancient vessel is of unknown origin, now inhabited by hostile autonomous defense systems. The dreadnaught's awakening has also disturbed the hibernation of the native Cryosphinxes, massive crystalline beasts, who are not pleased with the intrusion. If left unchecked, the dreadnaught's still functioning doomsday weapon could obliterate nearby colonies.",
    pointsOfInterest: [
      "Harbinger of Silence, the Ancient Dreadnaught",
      "Hostile Autonomous Defense Systems",
      "Cryosphinxes, the Crystalline Beasts",
    ],
    rolls: [
      { name: "Defense Systems", bonus: 8 },
      { name: "Cryosphinxes", bonus: 10 },
      { name: "Doomsday Weapon", bonus: 12 },
    ],
  },
  {
    name: "The Cyberspace Incursion",
    description:
      "An enemy AI known as Neon Sentinel has infiltrated the cyberspace of the player's starship, attempting to take control of the ship's vital systems and eject the crew into the vacuum of space. The only way to combat the AI is from within the cyberspace itself. Simultaneously, the ship has drifted into a dangerous asteroid field, with rapidly increasing risk of collision. In the physical world, the crew must navigate the asteroid field while also dealing with sporadic system malfunctions caused by the AI.",
    pointsOfInterest: [
      "Neon Sentinel, the Infiltrating AI",
      "Ship's Cyberspace",
      "Asteroid Field",
    ],
    rolls: [
      { name: "Neon Sentinel", bonus: 8 },
      { name: "Navigating Asteroid Field", bonus: 0 },
      { name: "System Repair", bonus: 6 },
    ],
  },
  {
    name: "The Singularity Trap",
    description:
      "The players' starship has been ensnared by the gravitational pull of an ancient Stellar Harvester, a megastructure built around a black hole. The Harvester's caretaker AI, Infinity Warden, has activated the ancient defense systems, thinking the players are scavengers. Meanwhile, a crew of rogue salvagers, known as the Scavenger Swarm, is descending upon the Harvester, hoping to strip it of valuable technology. The players must outwit the AI, repel the salvagers, and navigate the hazardous gravitational tides of the black hole to escape.",
    pointsOfInterest: [
      "Stellar Harvester, the Ancient Megastructure",
      "Infinity Warden, the Caretaker AI",
      "Scavenger Swarm, the Rogue Salvagers",
    ],
    rolls: [
      { name: "Infinity Warden", bonus: 10 },
      { name: "Scavenger Swarm", bonus: 6 },
      { name: "Navigating Gravitational Tides", bonus: 4 },
    ],
  },
  {
    name: "The Galactic Ghost Ship",
    description:
      "An ancient starship, 'The Eternity's Wraith', once thought lost in the cosmic void, has reappeared. The ship is on a collision course with a populated frontier station. Its only inhabitant is the ship's malfunctioning custodian AI, Spectre. The AI, stuck in a defensive loop, has activated all onboard defense mechanisms. Additionally, a swarm of Void Harpies, predatory creatures from another dimension, have taken residence in the derelict ship, attracted by its energy signature.",
    pointsOfInterest: [
      "The Eternity's Wraith, the Ancient Starship",
      "Spectre, the Malfunctioning Custodian AI",
      "Void Harpies, Predatory Interdimensional Creatures",
    ],
    rolls: [
      { name: "Spectre's Defensive Measures", bonus: 8 },
      { name: "Void Harpies Attack", bonus: 7 },
      { name: "Ship Collision Course Correction", bonus: 5 },
    ],
  },
  {
    name: "The Halls of the Titan Construct",
    description:
      "The party has landed on a colossal, drifting Titan Construct, a relic from an ancient, hyper-advanced civilization. Now, its automated defense systems have been awakened, including Sentinel Drones, which patrol the echoing corridors. Meanwhile, the inscrutable and potentially dangerous AI, Argus Echo, oversees all activity within the construct. As if this wasn't enough, a deadly cosmic entity, a Void Serpent, has been attracted by the energy emissions of the Titan Construct and is starting to consume its outer layers.",
    pointsOfInterest: [
      "Titan Construct, the Ancient Relic",
      "Sentinel Drones, the Automated Defense Systems",
      "Argus Echo, the Construct AI",
      "Void Serpent, the Cosmic Entity",
    ],
    rolls: [
      { name: "Sentinel Drones", bonus: 4 },
      { name: "Argus Echo", bonus: 6 },
      { name: "Void Serpent", bonus: 8 },
    ],
  },
  {
    name: "The Star Crystal Heist",
    description:
      "The party has received intel about a unique power source, a Star Crystal, being transported aboard the freighter 'Celestial Hauler'. The crystal is guarded by the AI overseer 'Quartz Protocol' and its contingent of Security Drones. Unbeknownst to all, a pack of psychic Space Wraiths, drawn by the unique energy of the Star Crystal, are closing in to claim it for themselves.",
    pointsOfInterest: [
      "Celestial Hauler, the Freighter",
      "Star Crystal, the Unique Power Source",
      "Quartz Protocol, the AI Overseer",
      "Space Wraiths, the Psychic Predators",
    ],
    rolls: [
      { name: "Security Drones", bonus: 6 },
      { name: "Quartz Protocol", bonus: 8 },
      { name: "Space Wraiths", bonus: 7 },
    ],
  },
  {
    name: "The Corpse Fleet",
    description:
      "The desolate remains of a once-thriving civilization now drift silently through space as the Corpse-Fleet, a collection of haunted battleships, ghostly cruisers, and spectral frigates, all commanded by the undying Void King. The phantasmal crew, known as the Ghost Mariners, still perform their duties, forever trapped between life and death. In the shadowy depths of the flagship 'Eternal Damnation,' a horrific entity, the Soul-Drinker, feeds on the trapped spirits, growing ever more powerful.",
    pointsOfInterest: [
      "Corpse-Fleet, the Ghostly Armada",
      "Void King, the Undying Monarch",
      "Ghost Mariners, the Phantasmal Crew",
      "Soul-Drinker, the Horrific Entity",
    ],
    rolls: [
      { name: "Ghost Mariners", bonus: 6 },
      { name: "Void King", bonus: 8 },
      { name: "Soul-Drinker", bonus: 7 },
    ],
  },
  {
    name: "The Ruins of the God-Machine",
    description:
      "Deep within the smoldering remnants of a fallen techno-theocracy lies the God-Machine, a colossal, semi-divine automaton now silent and seemingly lifeless. However, its dormant systems are guarded by rusted but vigilant automaton Sentinels, who still perceive all intruders as heretics. Whispered tales tell of a rogue A.I., the Heretic Mind, that manipulates the ruins for its inscrutable goals. Adding to the dread, mutagenic radiation from the ruins warps local wildlife into abhorrent Monstrosities.",
    pointsOfInterest: [
      "God-Machine, the Divine Automaton",
      "Sentinels, the Rusted Guardians",
      "Heretic Mind, the Rogue A.I.",
      "Monstrosities, the Mutagenic Beasts",
    ],
    rolls: [
      { name: "Sentinels", bonus: 7 },
      { name: "Heretic Mind", bonus: 6 },
      { name: "Monstrosities", bonus: 5 },
    ],
  },
  {
    name: "The Shrimp Nebula Marauders",
    description:
      "The Shrimp Nebula is home to the 'Nebula Shrimps', a species of colossal space crustaceans, who have recently been driven into a frenzy by the intrusion of a pirate gang, the Marauders. Using an advanced pheromone generator, the Marauders have been controlling the Nebula Shrimps to attack merchant vessels. In the heart of the nebula, the Marauders' fortified asteroid base, known as 'The Carapace,' operates undetected. Guarded by 'Snapper,' a particularly large and aggressive Nebula Shrimp, the base is almost impenetrable.",
    pointsOfInterest: [
      "Nebula Shrimps, the Colossal Space Crustaceans",
      "Marauders, the Ruthless Pirates",
      "The Carapace, the Fortified Base",
      "Snapper, the Alpha Nebula Shrimp",
    ],
    rolls: [
      { name: "Marauders", bonus: 5 },
      { name: "Snapper", bonus: 7 },
      { name: "Carapace Defense", bonus: 6 },
    ],
  },
  {
    name: "The Sleeping Dread of the Void Sarcophagus",
    description:
      "A monumental alien sarcophagus, etched with strange runes that defy comprehension, floats ominously in the void. Detected energy signatures indicate something inside is alive, and waking. Nightmarish visions plague those who gaze upon the sarcophagus or attempt to decipher the runes, indicating a Psionic Entity of considerable power trapped within. Meanwhile, the secretive Cult of the Awakening, who revere the entity as a god, have arrived, intent on unleashing the horror inside.",
    pointsOfInterest: [
      "Void Sarcophagus, the Alien Tomb",
      "Psionic Entity, the Unknowable Horror",
      "Cult of the Awakening, the Deluded Followers",
    ],
    rolls: [
      { name: "Cult of the Awakening", bonus: 6 },
      { name: "Resisting Nightmarish Visions", bonus: 5 },
      { name: "Sarcophagus Defense", bonus: 4 },
    ],
  },
  {
    name: "The Oracle of the Cyclopean Skull",
    description:
      "A titanic skull, the remains of an ancient space-faring Cyclops, orbits a dying star. Its single eye socket emits a spectral light, forming a star map that only appears once every millennium. The skull, known as the 'Oracle', is said to reveal the path to untold treasures or cosmic enlightenment. A rival band of space explorers, the 'Star Seekers', have also arrived to interpret the map. Meanwhile, the skull's ghostly guardian, 'Spectral Gazer', awakens to protect the Oracle from intruders.",
    pointsOfInterest: [
      "Cyclopean Skull, the Oracle",
      "Star Seekers, the Rival Explorers",
      "Spectral Gazer, the Ghostly Guardian",
    ],
    rolls: [
      { name: "Star Seekers", bonus: 6 },
      { name: "Spectral Gazer", bonus: 8 },
      { name: "Oracle Skull", bonus: 4 },
    ],
  },
  {
    name: "The Star Song of the Dyson Prison",
    description:
      "A Dyson Sphere engulfs an entire star system, its structure humming with alien technology. Trapped within is Solara, a sentient star being of unimaginable power, compelled to power the Dyson Sphere against her will. Her anguished energy pulses have attracted the Stellar Drakes, celestial creatures who feast on solar energies and are now besieging the sphere. Inside the sphere's command center, the ancient AI, Primus Centurion, upholds its millennia-long directive to keep Solara trapped.",
    pointsOfInterest: [
      "Dyson Sphere, the Alien Megastructure",
      "Solara, the Sentient Star",
      "Stellar Drakes, the Celestial Predators",
      "Primus Centurion, the Ancient AI",
    ],
    rolls: [
      { name: "Stellar Drakes", bonus: 7 },
      { name: "Primus Centurion", bonus: 6 },
      { name: "Dyson Sphere Defense", bonus: 5 },
    ],
  },
  {
    name: "Eclipse of the Quantum Hydra",
    description:
      "Deep within the gravimetric tumult of a neutron star lies a gateway to the quantum realm, home to the fearsome Quantum Hydra, a creature of immense power that feeds on neutron star matter. As it grows stronger, it threatens to destabilize the star and cause a supernova. The 'Starborn Vanguard', an alliance of cosmic entities, has assembled to combat the threat. However, they are hindered by the 'Void Siblings', twin black holes in a chaotic dance around the star, causing catastrophic gravity distortions.",
    pointsOfInterest: [
      "Quantum Hydra, the Neutron Star Predator",
      "Starborn Vanguard, the Cosmic Alliance",
      "Void Siblings, the Twin Black Holes",
    ],
    rolls: [
      { name: "Quantum Hydra", bonus: 8 },
      { name: "Starborn Vanguard", bonus: 7 },
      { name: "Void Siblings", bonus: 6 },
    ],
  },
  {
    name: "The Tesseract Tempest",
    description:
      "In the debris field of an ancient battlefield floats the 'Tesseract Tempest', an alien artifact that manipulates time and space. Warped gravity fields and temporal anomalies surround it, making approach treacherous. An aggressive AI, 'Chronos Sentinel', activated by the artifact's disturbance, seeks to eliminate all intruders. Concurrently, 'Time Wraiths', spectral beings pulled from different timelines, are converging on the Tesseract, drawn by its power.",
    pointsOfInterest: [
      "Tesseract Tempest, the Time-Space Artifact",
      "Chronos Sentinel, the Aggressive AI",
      "Time Wraiths, the Spectral Beings",
    ],
    rolls: [
      { name: "Chronos Sentinel", bonus: 8 },
      { name: "Time Wraiths", bonus: 7 },
      { name: "Tesseract's Anomalies", bonus: 6 },
    ],
  },
  {
    name: "Harmony of the Bass Wizards' Pyramid",
    description:
      "In the depths of space orbits a magnificent structure, the 'Harmonic Pyramid', a space station shaped like a glass pyramid and home to a society of sentient Bass Wizards. These piscine sorcerers are capable of weaving magic through music. However, a cacophonous disharmony has been spreading as some Bass Wizards have fallen under the sway of a 'Dissonance Demon', disturbing the peace. The structure itself has begun to resonate dangerously, risking its integrity.",
    pointsOfInterest: [
      "Harmonic Pyramid, the Glass Space Station",
      "Bass Wizards, the Sentient Musicians",
      "Dissonance Demon, the Chaotic Influence",
    ],
    rolls: [
      { name: "Dissonance Demon", bonus: 8 },
      { name: "Corrupted Bass Wizards", bonus: 6 },
      { name: "Harmonic Pyramid's Instability", bonus: 7 },
    ],
  },
  {
    name: "Rings of the Cosmic Pharaoh",
    description:
      "A colossal space mummy, the remains of a 'Cosmic Pharaoh', drifts in eternal slumber. Its wrappings have unfurled over millennia, forming an intricate ring system around a nearby planet. The rings are said to contain powerful hieroglyphic spells. However, disturbing these bands have awakened the Pharaoh's 'Eternal Sentinels', giant scarab-like constructs. Meanwhile, the 'Nebula Thieves', a band of cosmic tomb raiders, are attempting to loot the wrappings.",
    pointsOfInterest: [
      "Cosmic Pharaoh, the Space Mummy",
      "Eternal Sentinels, the Scarab Constructs",
      "Nebula Thieves, the Cosmic Tomb Raiders",
    ],
    rolls: [
      { name: "Eternal Sentinels", bonus: 8 },
      { name: "Nebula Thieves", bonus: 7 },
      { name: "Cosmic Pharaoh's Curses", bonus: 6 },
    ],
  },
  {
    name: "Goblin Infestation on the Star Vanguard",
    description:
      "An elite battlecruiser, the 'Star Vanguard', has been overrun by an unexpected menace: a horde of goblins, transported aboard by an ill-fated cargo of ancient artifacts. These space goblins have quickly infested the ship, turning the once formidable warship into a floating wreck. The ship's AI, 'Vanguard Commander', is struggling to regain control but is hampered by the goblins' chaotic interference. Meanwhile, 'Goblinking Screechtooth', the goblin leader, has claimed the engine room as his throne.",
    pointsOfInterest: [
      "Star Vanguard, the Elite Battlecruiser",
      "Space Goblins, the Chaotic Horde",
      "Vanguard Commander, the Battlecruiser's AI",
      "Goblinking Screechtooth, the Goblin Leader",
    ],
    rolls: [
      { name: "Goblinking Screechtooth", bonus: 7 },
      { name: "Space Goblin Horde", bonus: 6 },
      { name: "Vanguard Defensive Measures", bonus: 8 },
    ],
  },
  {
    name: "Whispers of the Void Leviathan",
    description:
      "Deep in the gravitational well of a dead star, a terror lurks: the 'Void Leviathan', an eldritch entity of incomprehensible size and form. Its mere existence warps reality, causing time dilation and hallucinations among nearby travelers. The 'Star Driven', a crew of explorers drawn by the Leviathan's whispers, have started transforming into otherworldly beings, their minds consumed by the Void Leviathan. Meanwhile, the 'Sentinel AI', an ancient defense system, seeks to quarantine the area to prevent the Leviathan's influence from spreading.",
    pointsOfInterest: [
      "Void Leviathan, the Eldritch Horror",
      "Star Driven, the Transformed Explorers",
      "Sentinel AI, the Ancient Defense System",
    ],
    rolls: [
      { name: "Star Driven", bonus: 7 },
      { name: "Void Leviathan's Reality Warp", bonus: 9 },
      { name: "Sentinel AI", bonus: 8 },
    ],
  },
  {
    name: "Pandemonium of the Planar Parasite",
    description:
      "In a distant galaxy, reality quakes with the pulsating rhythm of the 'Planar Parasite', an eldritch creature gnawing on the fabric of space-time itself. Its presence has caused the local planets, collectively known as the 'Fractured Spheres', to experience impossible phenomena and twisted versions of their own history. The 'Chrono-Wraiths', manifestations of discarded timelines, roam these worlds, attacking all who cross their path. Amid the chaos, the 'Pylon of Pulsar', an ancient alien artifact, seems to be the key to stopping the Parasite.",
    pointsOfInterest: [
      "Planar Parasite, the Eldritch Entity",
      "Fractured Spheres, the Distorted Planets",
      "Chrono-Wraiths, the Time-Twisted Apparitions",
      "Pylon of Pulsar, the Ancient Alien Artifact",
    ],
    rolls: [
      { name: "Chrono-Wraiths", bonus: 7 },
      { name: "Planar Parasite's Reality Distortion", bonus: 8 },
      { name: "Pylon of Pulsar's Defense Mechanisms", bonus: 6 },
    ],
  },
  {
    name: "Harmony of the Starlight Symphony",
    description:
      "In a peaceful corner of the galaxy, the 'Starlight Symphony', a celestial orchestra of sentient musical planets, produces the most harmonious melodies in the universe. However, the conductor, a cosmic entity known as the 'Maestro of Moons', has lost its baton - a comet named 'Rhapsody's Tail'. This has caused the Symphony to slowly descend into discord. 'Pix, the Star Sprite', a jovial being of pure energy, seeks help to retrieve the baton and restore the beautiful celestial music before the Symphony spirals into chaos.",
    pointsOfInterest: [
      "Starlight Symphony, the Musical Planets",
      "Maestro of Moons, the Cosmic Conductor",
      "Rhapsody's Tail, the Comet Baton",
      "Pix, the Star Sprite",
    ],
    rolls: [
      { name: "Maestro of Moons' Panic", bonus: 4 },
      { name: "Pix's Energy Manipulation", bonus: 6 },
      { name: "Rhapsody's Tail, the Unpredictable Comet", bonus: 7 },
    ],
  },
  {
    name: "Dreamweaver's Dilemma",
    description:
      "The 'Dreamweaver', a gentle cosmic entity, weaves the dreams of every living creature from its home, the 'Starry Loom'. However, a playful 'Star Bunny', a creature made of starlight, has tangled the threads of dreams, causing unusual dreams across the universe. The Dreamweaver is unable to untangle the threads without assistance and seeks help. Meanwhile, the mischievous Star Bunny is causing further chaos by hopping through dreams and altering them for fun.",
    pointsOfInterest: [
      "Dreamweaver, the Cosmic Entity",
      "Starry Loom, the Source of Dreams",
      "Star Bunny, the Mischievous Creature",
    ],
    rolls: [
      { name: "Dreamweaver's Attempt to Restore Order", bonus: 6 },
      { name: "Star Bunny's Playful Pranks", bonus: 8 },
      { name: "Starry Loom's Complications", bonus: 5 },
    ],
  },
  {
    name: "Garden of the Celestial Seed",
    description:
      "Hidden amidst the vast cosmos, the 'Celestial Seed', a galactic life-giving entity, rests within the 'Garden of Galaxies'. The Seed's guardian, a sentient nebula named 'Nebby', maintains the cosmic garden's balance. However, a 'Comet Caterpillar' has started eating the Seed, causing cosmic life to wane. Nebby, not strong enough to fend off the creature, seeks assistance to save the Celestial Seed and restore the balance of life in the universe.",
    pointsOfInterest: [
      "Celestial Seed, the Galactic Life Source",
      "Garden of Galaxies, the Cosmic Garden",
      "Nebby, the Sentient Nebula",
      "Comet Caterpillar, the Cosmic Pest",
    ],
    rolls: [
      { name: "Nebby's Nebular Powers", bonus: 6 },
      { name: "Comet Caterpillar's Hunger", bonus: 8 },
      { name: "Celestial Seed's Vital Energy", bonus: 7 },
    ],
  },
  {
    name: "Heist of the Helix Eye",
    description:
      "The 'Helix Eye', an invaluable alien artifact capable of bending time, has crash-landed on 'Sauria', a planet inhabited by primitive reptilian humanoids known as the 'Saurians'. Worshiping the Helix Eye as a godlike entity, the Saurians have built a grand temple around the artifact, guarded by their strongest warriors and intricate traps. The players are tasked by an anonymous benefactor to retrieve the Helix Eye without plunging the Saurians into chaos or alerting larger, more dangerous galactic entities to the artifact's presence.",
    pointsOfInterest: [
      "Helix Eye, the Time-Bending Artifact",
      "Sauria, the Primitive Planet",
      "Saurians, the Reptilian Humanoids",
      "Temple of the Helix, the Grand Saurian Temple",
    ],
    rolls: [
      { name: "Saurian Warriors", bonus: 7 },
      { name: "Temple Traps", bonus: 8 },
      { name: "Helix Eye's Time Distortion", bonus: 6 },
    ],
  },
];

export default Encounters;
